const getNavigationEntryType = (): PerformanceNavigationTiming['type'] | null => {
    if (typeof performance === 'undefined') {
        return null;
    }

    const [entry] = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
    return entry?.type ?? null;
};

export const isPageReload = (): boolean => getNavigationEntryType() === 'reload';
